<template>
  <div class="page">
    <div class="page-content">
      <div class="page-tool-bar">
        <div class="operation">
           <div>
                发放时间：
             <el-date-picker
                    placeholder="请选择发放时间"
                    v-model="queryForm.timeValue"
                    type="datetime"
                    format="yyyy-MM-dd HH:mm"
                    @change="adjustTimeToNearestHalfHour"
                    :picker-options="{
                      disabledDate(time) {
                        return time.getTime() < Date.now();
                      }
                    }"
                >
                </el-date-picker>
          </div>
          <div>
            发放组别：
           <el-select v-model="groupValue"  collapse-tags multiple placeholder="请选择发放组别">
                <el-option
                    v-for="item in group"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    >
                </el-option>
            </el-select>
        </div>
        <el-button type="success" :loading="false" @click="distributeVouchers">新增发放凭证</el-button>
        <div style="color: red;font-weight: 600;margin-left: 15px;">待兑付消费券：{{ waitMoney }}</div>
        <div style="color: red;font-weight: 600;margin-left: 15px;">昨日释放凭证金额：{{ yesterdayMoney ? yesterdayMoney : '--' }}</div>
        </div>
        <div class="icon-group">
          <span
            class="icon-box"
            @click="refreshShopBrandList"
          >
            <Icon color="#606266">
              <Refresh />
            </Icon>
          </span>
        </div>
      </div>
      <!-- 列表数据 -->
      <el-table
        height='100%'
        :data="shopBrandList"
        row-key="id"
        @selection-change="handleSelectionChange"
        size="small"
        border
        v-loading="loading"
      >
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="createTime"
          label="日期时间"
          min-width="10%"
        >
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="voucherGroup"
          label="发放组别"
          min-width="40%"
        >
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="status"
          label="发放情况"
          min-width="10%"
        > 
        <template slot-scope="scope">
           <div>
              {{ scope.row.status == 0 ? '待开始' : scope.row.status == 1 ? '发放中' : '已完成' }}
           </div>
        </template>
       </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="voucherNum"
          label="总凭证（条）"
          min-width="10%"
        >
         <template slot-scope="scope">
           <div>
              {{ scope.row.voucherNum  ?  thousandSeparator(scope.row.voucherNum) : '--' }}
           </div>
        </template>
       </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="subsidizedNum"
          label="已补贴（条）"
          min-width="10%"
        >
         <template slot-scope="scope">
           <div>
              {{ scope.row.subsidizedNum  ?  thousandSeparator(scope.row.subsidizedNum) : '--' }}
           </div>
        </template>
       </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="totalMoney"
          label="补贴可用消费券"
          min-width="10%"
        >
        <template slot-scope="scope">
           <div>
              {{ scope.row.totalMoney  ? thousandSeparator(scope.row.totalMoney) : '--' }}
           </div>
        </template>
       </el-table-column>
        
      </el-table>
      <div class="pagination-box">
        <el-pagination
          @size-change="sizeChange"
          @current-change="currentChange"
          :current-page.sync="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum"
          background
          :pager-count="7"
        >
        </el-pagination>
      </div>
    </div>
    
  </div>
</template>

<script>
import { Refresh} from '@v2icons/tabler';
import { get, post, deleteFun, upload ,postJson } from '@/utils/request.js';
export default {
   components: {
    Refresh
  },  
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetShopBrandList();
                this.getBrandList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetShopBrandList();
                this.getBrandList();
                this.$emit('resetCheckState');
            }
        }
    },
    data() {
        return {
            queryForm: {
                 groupNumber:'', 
                 timeValue: '',
                 },
            timeRange: [],
            loading: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            multipleSelection: [],
            shopBrandList: [],//列表数据
            group: [
                { value: '1', label: '组别1' },
                { value: '2', label: '组别2' },
                { value: '3', label: '组别3' },
                { value: '4', label: '组别4' },
                { value: '5', label: '组别5' },
                { value: '6', label: '组别6' },
                { value: '7', label: '组别7' },
                { value: '8', label: '组别8' },
                { value: '9', label: '组别9' },
                { value: '10', label: '组别10' },
                { value: '11', label: '组别11' },
                { value: '12', label: '组别12' },
                { value: '13', label: '组别13' },
                { value: '14', label: '组别14' },
                { value: '15', label: '组别15' },
                { value: '16', label: '组别16' },
                { value: '17', label: '组别17' },
                { value: '18', label: '组别18' },
                { value: '19', label: '组别19' },
                { value: '20', label: '组别20' },
                { value: '21', label: '组别21' },
                { value: '22', label: '组别22' },
                { value: '23', label: '组别23' },
                { value: '24', label: '组别24' },
                { value: '25', label: '组别25' },
                { value: '26', label: '组别26' },
                { value: '27', label: '组别27' },
                { value: '28', label: '组别28' },
                { value: '29', label: '组别29' },
                { value: '30', label: '组别30' },
                { value: '31', label: '组别31' }
            ],
            groupValue: [],
            waitMoney:null,
            yesterdayMoney:null,
        };
    },
    mounted() {
        this.getBrandList();
       
    },
    methods: {
        thousandSeparator(value) {
            if (!value && value !== 0) return '';
                const num = Number(value);
                if (isNaN(num)) return value;

                // 如果大于等于1000，使用千分位格式化
                if (num >= 1000) {
                return num.toLocaleString('en-US');
                }
                return num;
        },
         adjustTimeToNearestHalfHour(value) {
                if (value) {
                const minutes = value.getMinutes();
                let newMinutes;
                // 30分钟之前的选中都改为00（0-29分钟）
                if (minutes < 30) {
                    newMinutes = 0;
                }else {
                    newMinutes = 30;
                }
            
                // 设置分钟并重置秒数
                value.setMinutes(newMinutes);
                value.setSeconds(0);
                value.setMilliseconds(0);
                const d = new Date(value);
                const formattedDate = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')} ${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
                this.queryForm.timeValue = formattedDate;
                }
            },
        distributeVouchers(){
            if (!this.queryForm.timeValue) {
                this.$message.error('请选择发放时间');
                return;
            }
            if (this.groupValue.length === 0) {
                this.$message.error('请选择发放组别');
                return;
            }
            //将this.groupValue转换为字符串
            this.queryForm.groupNumber = this.groupValue.join(',');
            postJson('/shop/situation/insert',{
                voucherGroup: this.queryForm.groupNumber,
                startTime: this.queryForm.timeValue
            }).then((res)=>{
                   this.$alert(`今天${this.queryForm.timeValue}开始发放${this.queryForm.groupNumber}组`, '提示', {
                         confirmButtonText: '确定',
                         callback: () => {
                             if(res.success) {
                                this.$message.success(res.msg);
                                this.getBrandList()
                                this.queryForm.timeValue = '';
                                this.groupValue = [];
                                }else{
                                    this.$message.error(res.msg);
                                    this.getBrandList()
                                    this.queryForm.timeValue = '';
                                    this.groupValue = [];
                                }
                         },
                   })
            })
        },
        search() {
            this.isSearch = !this.isSearch;
        },
        resetShopBrandList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.shopBrandList = [];
        },
      
        refreshShopBrandList() {
            this.resetShopBrandList();
            this.getBrandList();
        },
        // 列表数据请求
        getBrandList() {
                this.loading = true;
                get(`/shop/situation/queryList`, {
                    pageNum: this.currentPage,
                    pageSize: this.pageSize
                }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.shopBrandList = res.page.list;
                        this.totalNum = res.page.total;
                        this.waitMoney = res.totalMoney
                        this.releasedYesterday()
                    }
                });  
             },
        releasedYesterday(){
              get('/biz/incomevoucherrecord/sumIncomeRecord',{}).then((res) => {
                if(res.success){
                  this.yesterdayMoney = res.sumMoney
                }
            });
        }, 
        resetQueryFrom() {
            this.getBrandList();
        },
        
        handleSelectionChange(value) {
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getBrandList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getBrandList();
        },
    }
};
</script>

<style lang="scss" scoped>



::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 30px;
    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }
}
::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 178px;
    height: 178px;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 178px;
    text-align: center;
}
.avatar {
    width: 178px;
    height: 178px;
    display: block;
}
.logo-img {
    margin-left: 50%;
    transform: translate(-50%, 0);
}
.count{
    margin-right:1.5625vw;
}
</style>
